import Container from "../Container";
import classes from "./index.module.scss";
import { clip } from "../data";
import { v4 as uuid } from "uuid";
import Card from "./Card";
import { useDeferredValue, useEffect } from "react";

export default function Clip() {
  const deferredClip = useDeferredValue(clip);

  function removeClass(images) {
    images.forEach((img) => {
      img.classList.remove(classes.card_active);
    });
  }
  function addClass(image) {
    image.classList.add(classes.card_active);
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      const images = [...document.querySelectorAll(`.${classes.card}`)];

      images.forEach((image, index) => {
        if (index === 0) {
          addClass(image);
        }
        image.addEventListener("click", () => {
          removeClass(images);
          addClass(image);
        });
      }, 500);

      return () => clearTimeout(timeout);
    });
  }, []);

  return (
    <section>
      <Container>
        <ul className={classes.list}>
          {deferredClip.map(({ images, title, text }) => (
            <Card key={uuid()} images={images} title={title} text={text} />
          ))}
        </ul>
      </Container>
    </section>
  );
}
